import 'regenerator-runtime/runtime';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { GlobalActions, GlobalPut, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { Vorversicherer as VorversichererBff } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { Vorversicherer } from '../data/vorversicherung';
import { CheckoutActions } from '../checkout.actions';

export const URL_VORVERSICHERERLISTE = '/privatschutz/api/vorversicherer';

export function* watchVorversichererListRequest() {
  yield takeEvery(
    GlobalActions.AUTHENTICATION_SUCCESSFUL,
    safeSaga(getVorversichererListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CheckoutActions.VORVERSICHERERLISTE_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getVorversichererListSaga() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_VORVERSICHERERLISTE,
      successEvent: CheckoutActions.VORVERSICHERERLISTE_REQUEST_SUCCESSFUL,
      errorEvent: CheckoutActions.VORVERSICHERERLISTE_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction) {
  const vorversichererResponse: VorversichererBff[] = successAction.payload;
  const vorversichererListe = getVorversichererListeOfBffResponse(vorversichererResponse);
  yield put(new CheckoutActions().vorversichererListeRetrieved(vorversichererListe));

  function getVorversichererListeOfBffResponse(
    versicherungDataBff: VorversichererBff[],
  ): Array<Vorversicherer> {
    return versicherungDataBff.map(elem => {
      return {
        label: elem.text,
        value: elem.wert,
        plz: elem.plz,
        ort: elem.ort,
      };
    });
  }
}
